import React from 'react';
import data from '../../aboutClinic.json';

const { aboutClinic } = data;

const AboutClinic = ({aboutClinic}) => {
  const { id, sectionLabel, mainQuote, supportingText, image } = aboutClinic;

  return (
    <section
      id={id}
      className="w-full bg-white overflow-hidden  "
      style={{ minHeight: '320px' }}
    >
      <div
        // className="flex flex-col lg:flex-row items-stretch"
        className="flex flex-col lg:flex-row items-start lg:items-stretch"
      >

        {/* ── Left Content ── */}
        <div
          // className="w-full lg:w-3/5 flex flex-col justify-center gap-5 py-10 md:py-14 lg:py-16"
          className="w-full lg:w-3/5 flex flex-col justify-center gap-5 py-6 md:py-10 lg:py-16"
          style={{ paddingLeft: 'max(1.5rem, calc((100vw - 1280px) / 2 + 2rem))', paddingRight: '3rem' }}
        >

          {/* Watermark label */}
          <span
            className="font-black uppercase select-none leading-none block"
            style={{
              color: 'var(--gray-200)',
              fontSize: 'clamp(2rem, 5.5vw, 4rem)',
              letterSpacing: '0.06em',
              lineHeight: 1.05,
            }}
          >
            {sectionLabel}
          </span>

          {/* Quote icon */}
          <span
            className="font-serif select-none block"
            style={{
              color: 'var(--gray-300)',
              fontSize: 'clamp(1.8rem, 3.5vw, 3rem)',
              lineHeight: 1,
            }}
            aria-hidden
          >
            &#x201D;
          </span>

          {/* Main bold quote */}
          <h2
            className="ava-heading-md"
          >
            {mainQuote}
          </h2>
          {/* Supporting paragraph */}
          <p
            className="ava-text-sm lg:max-w-[520px]"
          >
            {supportingText}
          </p>

        </div>

        {/* ── Right Image — flush to right, no padding, full height ── */}
        <div className="w-full lg:w-2/5 flex-shrink-0 min-h-54 lg:min-h-0">
          <img
            src={image.src}
            alt={image.alt}
            className="w-full object-cover object-center aspect-[21/9] lg:aspect-auto lg:h-full "
            draggable={false}
          />
        </div>

      </div>
    </section>
  );
};

export default AboutClinic;